import * as React from "react";
import { useGetMetaPrinter } from '../../hooks/useGetMetaPrinter';

type Props = {
    label?: string;
    value?: string;
    type: string | 'text';
};

const PrinterInputs = ( props: Props ) => {
    const { liveUpdateMetaPrinter } = useGetMetaPrinter();
    const [ value, SetValue ] = React.useState( props.value || "" );
    const inputId = `input-${props.label?.replace(/\s+/g, '-').toLowerCase()}`;

    React.useEffect(() => {
        SetValue(props.value || "");
    }, [props.value]);

	const handleChange = ( e: React.ChangeEvent<HTMLInputElement> ) => {
		const newData = {
			meta: e.currentTarget.name,
			value: e.currentTarget.value,
		};
		liveUpdateMetaPrinter( newData );
		
		SetValue( newData.value );
	};

    return (
        <div>
            <div className="flex items-center gap-2 p-2">
            <label htmlFor={inputId}>{props.label}</label>

                <input
                    id={`input-${props.label?.replace(/\s+/g, '-').toLowerCase()}`}

                    className="flex-1 border-none indent-3 drop-shadow-c-dsh-1 cursor-pointer h-9 text-base"
                    type={ props.type }
                    name={ props.label }
                    value={ value }
                    onChange={ handleChange }
                    onInput={ handleChange }
                />
            </div>
        </div>
    );
};

export default PrinterInputs;
